import $ from 'jquery';
import 'slick-carousel';

/**
 * ProductSlider Class
 * @class ProductSlider
 */

export default class ProductSlider {
    slick;
    constructor(element) {
        this.element = element;
        this.visibleOverlayClass = 'product-slider--overlay';
        this.itemClass = 'product-slider__item';
        this.visualClass = 'product-slider__visual';
        this.contentClass = 'product-slider__content';
        this.contentVisibleClass = 'product-slider__content--visible';
        this.closeBtnClass = 'product-slider__close-btn';
        this.initSlider();

        window.addEventListener('resize', () => {
            if (!this.slick) {
                this.closeOverlay();
            }
        });

        element.querySelectorAll(`.${this.itemClass}`).forEach(item => {
            item.querySelector(`.${this.visualClass}`).addEventListener('click', () => {
                this.openOverlay(item);
            });

            item.querySelector(`.${this.closeBtnClass}`).addEventListener('click', () => {
                this.closeOverlay(item);
            });
        });
    }

    openOverlay(item) {
        item.querySelector(`.${this.contentClass}`).classList.add(this.contentVisibleClass);
        this.element.classList.add(this.visibleOverlayClass);

        setTimeout(() => {
            this.applyOverlayheight();
        }, 100);

        this.scrollUp();
        this.destroySlider();
    }
    
    closeOverlay(item) {
        document.querySelector(`.${this.contentVisibleClass}`).classList.remove(this.contentVisibleClass);
        this.element.classList.remove(this.visibleOverlayClass);
        this.removeOverlayheight();
        this.initSlider();
        this.updateCurrentSlide(item);
    }

    updateCurrentSlide(item) {
        const clickedParent = item.parentElement.parentElement;
        const dataIndex = clickedParent.getAttribute('data-slick-index');
        const slideElems = this.element.querySelectorAll('.slick-slide');
        let current;

        for ( let i = 0; i < slideElems.length; i++) {
            if ( slideElems[i].getAttribute('data-slick-index') === dataIndex) {
                current = i;
            }
        }

        $('.product-slider__slides').slick('slickGoTo', current, true );
    }
    
    initSlider() {
        this.slick = $('.product-slider__slides').slick({
            dots: true,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 4,
            prevArrow: this.element.querySelector('.slick__arrow--left'),
            nextArrow: this.element.querySelector('.slick__arrow--right'),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    destroySlider() {
        $('.product-slider__slides').slick('unslick');
        this.glide = undefined;
    }

    scrollUp() {
        this.element.scrollIntoView({block: "start", behavior: "smooth"});
    }

    applyOverlayheight() {
        this.element.setAttribute("data-opened","true");
        this.element.style.height = `${this.element.querySelector(`.${this.contentVisibleClass}`).offsetHeight}px`;
    }
    
    removeOverlayheight() {
        this.element.setAttribute("data-opened","false");
        this.element.style.height = 'auto';
    }
}
